import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../src/Page/login/Login";
import Dashboard from "../src/Page/Dashboard/Dashboard";
import Chat from "../src/Page/Chat/Chat";
import SessioReports from "../src/Page/SessionReports/SessionReports";
import AgentReports from "../src/Page/AgentReports/AgentReport";
import Calenders from "../src/Page/Calenders/Calender";
import Contacts from "../src/Page/Contacts/Contacts";
import DashboardContainer from "./Page/EmailComponents/Dashboard/DashboardContainer";
import InboxContainer from "./Page/EmailComponents/Inbox/InboxContainer";
import NewEmailContainer from "./Page/EmailComponents/Inbox/NewEmailContainer";
import SentItemsContainer from "./Page/EmailComponents/Inbox/SentItemsContainer";
import CompletedContainer from "./Page/EmailComponents/Inbox/CompletedContainer";
import Main from "./Page/Main/Main";
import PowerBi from "./Page/PowerBi/PowerBi";
import PowerBiV2 from "./Page/powerBiv2/powerBi";
import PowerBiDashboard from "./Page/PowerBi Dashboard/PowerBiDashboard";
import Bank from "../src/Page/BankPage/Bank";
import ChatForClient from "../src/components/clientChat/index";
import ChatIndex from "../src/components/clientChat/chatindex";
import MultimediaSearch from "./Page/Multimedia/MultimediaSearch";
import Cms from "./Page/CMS/Cms";
import AgentContact from "./Page/AgentContact/AgentContact";
import SupervisorContact from "./Page/SupervisorContact/SupervisorContact";
import Statistic from "./components/WebStatistic-component/WebStatistic";
import AgentStatus from "./components/Agent-Status/AgentStatus.component";
import ViewAllAgentDialogBox from "./Page/Dashboard/ViewAllAgentDialogBox";
import QueueChat from "./Page/QueueChat/QueueChat";
import ReportMainMenu from "./Page/Reports/ReportMainMenu";
import MissedCall from "./Page/MissedCall/MissedCall";
import Campaign from "./Page/Campaign/Campaign";
import MakeCall from "./Page/MakeCall/MakeCall";
import AgentLoginLogout from "./Page/AgentLoginLogout/AgentLoginLogout";
import AgentStatusReport from "./Page/AgentStatusReport/AgentStatusReport";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="customerPortal" element={<Bank />} />
      <Route path="ChatForClient" element={<ChatForClient />} />
      <Route path="ChatIndex" element={<ChatIndex />} />
      <Route path="Agent-List" element={<ViewAllAgentDialogBox />} />

      <Route path="/main" element={<Main />}>
        <Route path="Dashboard" element={<Dashboard />} />
        <Route path="Chat" element={<Chat />} />
        <Route path="SessioReports" element={<SessioReports />} />
        <Route path="AgentReports" element={<AgentReports />} />
        <Route path="CMS" element={<Cms />} />
        <Route path="Agent-Contact" element={<AgentContact />} />
        <Route path="Contacts" element={<Contacts />} />
        <Route path="Queue-Chat" element={<QueueChat />} />
        <Route path="Campaign" element={<Campaign />} />

        <Route path="agentloginlogoutreport" element={<AgentLoginLogout />} />
        <Route path="agentstatusreport" element={<AgentStatusReport />} />



        <Route path="Calenders" element={<Calenders />} />
        <Route path="mail" element={<DashboardContainer />} />
        <Route path="newemail" element={<NewEmailContainer />} />
        <Route path="inbox" element={<InboxContainer />} />
        <Route path="completeemail" element={<CompletedContainer />} />
        <Route path="sentitems" element={<SentItemsContainer />} />
        <Route path="powerBi" element={<PowerBi />} />
        <Route path="powerBiv2" element={<PowerBiV2 />} />
        <Route path="powerBiDashboard" element={<PowerBiDashboard />} />
        <Route path="multimediasearch" element={<MultimediaSearch />} />
        <Route path="supervisor" element={<MultimediaSearch />} />
        <Route path="supervisorContact" element={<SupervisorContact />} />
        <Route path="statistic" element={<Statistic />} />
        <Route path="AgentStatus" element={<AgentStatus />} />
        <Route path="reports" element={<ReportMainMenu />} />
        <Route path="MissedCalls" element={<MissedCall />} />
        <Route path="MakeCalls" element={<MakeCall />} />
      </Route>
    </Routes>
  );
};

export default App;
